import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=79b4511a&"
import script from "./Modulos.vue?vue&type=script&lang=js&"
export * from "./Modulos.vue?vue&type=script&lang=js&"
import style0 from "./Modulos.vue?vue&type=style&index=0&id=79b4511a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports